import React, { FC } from "react";
import { Button } from "@src/ui/button";
import { useOpenMergeLink } from "./hooks/useOpenMergeLink";
import PlusIcon from "@src/ui/icons/18px/plus";

type Props = {
  variant?: "default" | "outline";
};

const MergeLinkButton: FC<Props> = ({ variant = "default" }) => {
  const openMergeLink = useOpenMergeLink();
  return (
    <Button onClick={openMergeLink} variant={variant}>
      <PlusIcon />
      Add integration
    </Button>
  );
};

export default MergeLinkButton;
